import { render, staticRenderFns } from "./questionBodyComponent.vue?vue&type=template&id=5b133422&scoped=true"
import script from "./questionBodyComponent.vue?vue&type=script&lang=js"
export * from "./questionBodyComponent.vue?vue&type=script&lang=js"
import style0 from "./questionBodyComponent.vue?vue&type=style&index=0&id=5b133422&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b133422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b133422')) {
      api.createRecord('5b133422', component.options)
    } else {
      api.reload('5b133422', component.options)
    }
    module.hot.accept("./questionBodyComponent.vue?vue&type=template&id=5b133422&scoped=true", function () {
      api.rerender('5b133422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionBodyComponent.vue"
export default component.exports